module.exports = __webpack_public_path__ + "static/media/contract-news-banner-sp.8edb29bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/contract-news-banner-sp.png
// module id = 489
// module chunks = 0